import { useSearchParams } from "react-router-dom"

export const useParamsUrl = (paramKeyName) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const removeQueryParams = () => {
        const param = searchParams.get(paramKeyName);

        if (param) {
            searchParams.delete(paramKeyName);
            setSearchParams(searchParams);
        }
    };
    const paramValue = searchParams.get(paramKeyName)
    return [paramValue, setSearchParams, removeQueryParams]
}